import React from "react";

const ContractTypeList = React.lazy(() =>
  import("./ContractTypeList").then((module) => ({
    default: module.ContractTypeList,
  })),
);
const ContractTypeCreate = React.lazy(() =>
  import("./ContractTypeCreate").then((module) => ({
    default: module.ContractTypeCreate,
  })),
);
const ContractTypeEdit = React.lazy(() =>
  import("./ContractTypeEdit").then((module) => ({
    default: module.ContractTypeEdit,
  })),
);

export default {
  list: ContractTypeList,
  create: ContractTypeCreate,
  edit: ContractTypeEdit,
  recordRepresentation: "name",
};
